

const TagFilter = ({tags, handleRemoveTag, RemoveAllTags}) => {

    const RemoveIcon = process.env.PUBLIC_URL + '/images/icon-remove.svg';


    return (
        <div className="flex justify-between rounded-lg border-2 p-5 flex-row">
            <div className="flex flex-wrap gap-5">
                {tags.map((tag, index) => (
                    <div key={index} className="flex justify-center items-center gap-3 text-[1.2rem] font-bold bg-light-grayish-cyan-filter text-desaturated-dark-cyan p-1 px-2 rounded-md">
                    <span className="max-[400px]:text-[15px]">{tag}</span>
                    <img onClick={() => handleRemoveTag(tag)} src={RemoveIcon} alt="" className="bg-dark-grayish-cyan h-full w-8 max-[400px]:w-7 p-2 hover:bg-very-dark-grayish-cyan hover:cursor-pointer"  />
                </div>
                ))}
            </div>
            <button onClick={RemoveAllTags} className="text-desaturated-dark-cyan text-[18px] max-[400px]:text-[15px] font-bold hover:underline">Clear</button>
        </div>
    );
}
 
export default TagFilter;